import { c as _c } from "react/compiler-runtime";
import { type ToastType } from '@/app/_shared/enums';
import Alert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import Fade from '@mui/material/Fade';
import Slide from '@mui/material/Slide';
import Grow from '@mui/material/Grow';
import { useState } from 'react';
import { type TransitionProps } from '@mui/material/transitions';
interface ToastProps {
  message: string;
  type: ToastType;
  animationDuration?: number;
  animationType?: 'grow' | 'fade' | 'slide';
  /** Invoked callback on Toast fadeout */
  onClose: () => void;
  duration?: number;
}
export const Toast = t0 => {
  const $ = _c(15);
  const {
    message,
    type,
    onClose,
    duration: t1,
    animationDuration: t2,
    animationType: t3
  } = t0;
  const duration = t1 === undefined ? 1500 : t1;
  const animationDuration = t2 === undefined ? 500 : t2;
  const animationType = t3 === undefined ? "grow" : t3;
  const [isAnimating, setIsAnimating] = useState(true);
  let t4;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsAnimating(false);
    $[0] = t4;
  } else {
    t4 = $[0];
  }
  const handleClose = t4;
  let animationComponent = Grow;
  if (animationType === "slide") {
    animationComponent = Slide;
  } else {
    if (animationType === "fade") {
      animationComponent = Fade;
    }
  }
  let t5;
  if ($[1] !== animationDuration || $[2] !== isAnimating || $[3] !== onClose) {
    t5 = {
      in: isAnimating,
      timeout: animationDuration,
      onExited: onClose
    };
    $[1] = animationDuration;
    $[2] = isAnimating;
    $[3] = onClose;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "100%",
      "& .MuiAlert-message": {
        whiteSpace: "pre-line"
      }
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== message || $[7] !== type) {
    t7 = <Alert onClose={handleClose} severity={type} sx={t6}>{message}</Alert>;
    $[6] = message;
    $[7] = type;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== animationComponent || $[10] !== animationDuration || $[11] !== duration || $[12] !== t5 || $[13] !== t7) {
    t8 = <Snackbar open={true} autoHideDuration={duration} transitionDuration={animationDuration} TransitionComponent={animationComponent} onClose={handleClose} TransitionProps={t5}>{t7}</Snackbar>;
    $[9] = animationComponent;
    $[10] = animationDuration;
    $[11] = duration;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};